import CodeCell from './cell.detail.component'

export { CodeCell }
